gwHandler = {
    $radioInput : $('[data-field-type="radio"]'),
    $checkboxInput : $('[data-field-type="checkbox"]'),
    $donationForm : $('.give-form'),

    rebuildLabel : function(obj) {
        var self = this;

        $(obj).find('label').each(function() {
            var input = $(this).find('input').clone();
            var label = document.createElement('label');
            $(label).attr('for', $(this).attr('for'));
            $(label).html($(input).attr('value'));

            $(this).html('');
            $(this).append(input);
            $(this).append(label);
            $(this).addClass('label-container');
        });
    },

    relatedInput : function(dummyObj, targetObj) {
        var self = this;

        $(dummyObj).on('input', function() {
            $(targetObj).val($(this).val());
        });
    },

    init : function() {
        var self = this;

        self.$radioInput.each(function() {
            self.rebuildLabel(this);
        });

        self.$donationForm.each(function() {
            var giftFrequency = $(this).find('[data-field-name="gift_frequency"]').clone();
            var giftInfo = $(this).find('[data-field-name="gift_information"]').clone();
            var lastDescription = $(this).find('[data-field-name="last_description"]').clone();
            var totalWrap = $(this).find('.give-total-wrap');
            var levelWrap = $(this).find('.give-donation-levels-wrap');
            var purchaseForm = $(this).find('#give_purchase_form_wrap');
            var frequency = $(this).find('.give-recurring-period');
            var selfForm = $(this);
            var $paypalLogo = $('body').find('.paypal-logo.set-active').clone().removeClass('hide');
            var $paypalLogoWhite = $('body').find('.paypal-logo.set-inactive').clone().removeClass('hide');
            var $stripeLogo = $('body').find('.stripe-logo.set-active').clone().removeClass('hide');
            var $stripeLogoWhite = $('body').find('.stripe-logo.set-inactive').clone().removeClass('hide');
            var $giveBtn = $(this).find('.give-donation-level-btn');

            $paypalLogo.insertAfter($(this).find('#give-gateway-option-paypal'));
            $paypalLogoWhite.insertAfter($(this).find('#give-gateway-option-paypal'));
            $stripeLogo.insertAfter($(this).find('#give-gateway-option-stripe'));
            $stripeLogoWhite.insertAfter($(this).find('#give-gateway-option-stripe'));
            $(this).find('#give-gateway-option-paypal').parent().addClass('has-image');
            $(this).find('#give-gateway-option-stripe').parent().addClass('has-image');

            $(giftFrequency).each(function() {
                var $monthly = $(this).find('input[value="Monthly"]');
                var $once = $(this).find('input[value="One-Time"]');

                $($monthly).change(function() {
                    if ($(this).is(':checked')) {
                        $(frequency).prop('checked', true);
                    }
                });

                $($once).change(function() {
                    if ($(this).is(':checked')) {
                        $(frequency).prop('checked', false);
                    }
                });

            });

            $(this).find('[for="give-amount"').html('Gift Amount');

            $(this).find('[data-field-name="gift_frequency"]').remove();
            $(this).find('[data-field-name="gift_information"]').remove();
            $(this).find('[data-field-name="last_description"]').remove();

            $(giftInfo).insertBefore(totalWrap);
            $(giftFrequency).insertBefore(totalWrap);
            $(totalWrap).find('label').addClass('field-padd').insertBefore(levelWrap);
            $(totalWrap).insertAfter(levelWrap);

            var customButton = $( "<button>" );
            $(this).find('#give-purchase-button').each(function() {

                $.each( this.attributes, function(){ 
                    $(customButton).attr( this.name, this.value );
                } );
            
                $(customButton).addClass('button button-secondary custom-submit-button');
                $(customButton).html('Donate');
            });

            $(customButton).insertAfter(purchaseForm);
            $(lastDescription).insertAfter(purchaseForm);

            $(customButton).on('click', function() {
                selfForm.find('input#give-first').val(selfForm.find('[data-field-name="first_name"] input').val());
                selfForm.find('input#give-last').val(selfForm.find('[data-field-name="last_name"] input').val());
                selfForm.find('input#give-company').val(selfForm.find('[data-field-name="organization_company_name"] input').val());
                selfForm.find('input#give-email').val(selfForm.find('[data-field-name="email"] input').val());
            });

            $($giveBtn).each(function() {
                $(totalWrap).find('.give-donation-amount').addClass('hide');
                if ($(this).data('default') == '1') {
                    $(this).addClass('is-selected');
                }

                $(this).on('click', function() {
                    $($giveBtn).removeClass('is-selected');
                    $(this).addClass('is-selected');

                    if ($(this).hasClass('give-btn-level-custom')) {
                        $(totalWrap).find('.give-donation-amount').removeClass('hide');
                    } else {
                        $(totalWrap).find('.give-donation-amount').addClass('hide');
                    }
                });
            });

        });
    }
}